(function () {
  'use strict';

  // Product page tab switching
  function initTabs() {
    document.querySelectorAll('.tabs').forEach(function (tabs) {
      var heads = tabs.querySelectorAll('[data-tab]');
      var bodies = tabs.querySelectorAll('[data-tab-body]');
      heads.forEach(function (head) {
        head.addEventListener('click', function () {
          var target = head.getAttribute('data-tab');
          heads.forEach(function (h) { h.classList.remove('active'); });
          head.classList.add('active');
          bodies.forEach(function (b) {
            b.style.display = b.getAttribute('data-tab-body') === target ? '' : 'none';
          });
        });
      });
    });
  }

  // FAQ details auto-close siblings (optional; also works natively)
  function initFaq() {
    document.querySelectorAll('.faq details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        // leave individual toggles natural; this hook is here for future enhancement
      });
    });
  }

  // Product quantity +/-
  function initQty() {
    document.querySelectorAll('.qty').forEach(function (qty) {
      var input = qty.querySelector('input[type="number"]');
      if (!input) return;
      qty.querySelectorAll('button[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-qty');
          var v = parseInt(input.value, 10) || 1;
          input.value = dir === '+' ? v + 1 : Math.max(1, v - 1);
        });
      });
    });
  }

  // Purchase option toggle (one-time vs subscribe, UI only)
  function initPurchaseOpts() {
    document.querySelectorAll('.purchase-opts').forEach(function (wrap) {
      var cards = wrap.querySelectorAll('.opt-card');
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) { c.classList.remove('active'); });
          card.classList.add('active');
          var input = card.querySelector('input[type="radio"]');
          if (input) input.checked = true;
        });
      });
    });
  }

  // Quiz step navigation (client-side only)
  function initQuiz() {
    document.querySelectorAll('[data-quiz]').forEach(function (card) {
      var opts = card.querySelectorAll('[data-opt]');
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) { o.classList.remove('selected'); });
          opt.classList.add('selected');
        });
      });
    });
  }

  // Collection tabs (section: sections/collection-tabs.liquid)
  function initCollectionTabs() {
    document.querySelectorAll('[data-collection-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-ct-tab]');
      var bodies = root.querySelectorAll('[data-ct-body]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-ct-tab');
          tabs.forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active');
          bodies.forEach(function (b) {
            b.style.display = b.getAttribute('data-ct-body') === target ? '' : 'none';
          });
        });
      });
    });
  }

  // Mobile nav toggle (placeholder hook)
  function initMobileNav() {
    var btn = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('.nav ul');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTabs(); initFaq(); initQty(); initPurchaseOpts(); initQuiz(); initCollectionTabs(); initMobileNav();
    });
  } else {
    initTabs(); initFaq(); initQty(); initPurchaseOpts(); initQuiz(); initMobileNav();
  }
})();
